const Hindi = {
  //COMMON
  nameRequired: "नाम आवश्यक है.",
  firstNameRequired: "पहला नाम आवश्यक है।",
  lastNameRequired: "अंतिम नाम आवश्यक है।",
  emailRequired: "ईमेल आवश्यक है।",
  phoneRequired: "फ़ोन नंबर आवश्यक है।",
  genderRequired: "लिंग आवश्यक है।",
  dobRequired: "जन्म तिथि आवश्यक है।",
  firstNamelength: "पहला नाम कम से कम 3 अक्षरों का होना चाहिए।",

  experienceRequired: "अनुभव आवश्यक है.",
  suggestionRequired: "सुझाव आवश्यक है.",
  onlyAlphabetsAllowed: "केवल अक्षर और रिक्त स्थान की अनुमति है.",

  //PROFILE
  pincodeRequired: "मान्य 6 अंकों का पिनकोड आवश्यक है।",
  stateRequired: "राज्य आवश्यक है।",
  districtRequired: "जिला आवश्यक है।",
  cityRequired: "शहर/कस्बा/गांव आवश्यक है।",
  addressRequired: "पता आवश्यक है।",
  religionRequired: "धर्म आवश्यक है।",
  templeFrequencyRequired: "मंदिर दर्शन की आवृत्ति आवश्यक है।",
  languageRequired: "भाषा आवश्यक है।",
  phoneTenDigits: "फ़ोन नंबर 10 अंकों का होना चाहिए।",
  phonestarts:"संख्या 0 से शुरू नहीं हो सकती।",
  aadharInvalid: "आधार नंबर 12 अंकों का होना चाहिए।",
  passportInvalid:
    "पासपोर्ट नंबर 1 अक्षर और 7 अंकों का होना चाहिए (जैसे K1234567)।",
  firstNameInvalid: "पहला नाम केवल अक्षरों और रिक्त स्थानों से बना होना चाहिए।",
  lastNameInvalid: "अंतिम नाम केवल अक्षरों और रिक्त स्थानों से बना होना चाहिए।",

  // PASSWORD
  currentPasswordRequired: "वर्तमान पासवर्ड आवश्यक है।",
  newPasswordRequired: "नया पासवर्ड आवश्यक है।",
  confirmPasswordRequired: "पासवर्ड की पुष्टि आवश्यक है।",
  currentPasswordInvalid:
    "वर्तमान पासवर्ड कम से कम 8 अक्षरों का होना चाहिए और इसमें एक बड़ा अक्षर, एक छोटा अक्षर, एक संख्या और एक विशेष वर्ण शामिल होना चाहिए।",
  newPasswordInvalid:
    "नया पासवर्ड कम से कम 8 अक्षरों का होना चाहिए और इसमें एक बड़ा अक्षर, एक छोटा अक्षर, एक संख्या और एक विशेष वर्ण शामिल होना चाहिए।",
  confirmPasswordInvalid:
    "पासवर्ड की पुष्टि कम से कम 8 अक्षरों की होनी चाहिए और इसमें एक बड़ा अक्षर, एक छोटा अक्षर, एक संख्या और एक विशेष वर्ण शामिल होना चाहिए।",
  passwordsNotMatch: "नया पासवर्ड और पुष्टि पासवर्ड मेल नहीं खाते।",
  emojiNotAllowed: "पासवर्ड में इमोजी की अनुमति नहीं है।",
  incorrectCurrentPassword: "आपके द्वारा दर्ज किया गया वर्तमान पासवर्ड गलत है।",
  sameAsCurrentPassword: "नया पासवर्ड वर्तमान पासवर्ड के समान नहीं हो सकता।",

  //IMAGE
  fileTooLarge: "फ़ाइल का आकार 2MB से अधिक नहीं होना चाहिए।",
  invalidFileType: "अमान्य फ़ाइल प्रकार। कृपया JPG/JPEG या PNG छवि अपलोड करें।",
  imageUploadFailed: "इमेज अपलोड विफल रहा। कृपया पुनः प्रयास करें।",
};

export default Hindi;
